const { getElement } = window.BAO.Utils
class SiteNotifications extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.showUnreadNotificationPulse()

    if (this.unreadNotificationCount > 0) {
      this.externalEls.count.elements.forEach(element => {
        element.innerHTML = this.unreadNotificationCount

        element.ariaHidden = false
      })

      this.externalEls.trigger.elements.forEach(element => {
        element.dataset.ringing = true
      })
    }
  }

  setupListeners () {
    super.setupListeners()

    this.els.item.elements.forEach(element => {
      this.listeners.add(element, 'click', () => {
        this.notificationsClicked = element.dataset.id
        getElement(this.els.unread.selector, {
          context: element,
        }).ariaHidden = true
      })
    })
  }

  triggerEvent () {
    this.notificationsRead = this.dataset.ids

    this.externalEls.trigger.elements.forEach(element => {
      element.dataset.ringing = false
    })

    this.externalEls.count.elements.forEach(element => {
      element.ariaHidden = true
    })
  }

  showUnreadNotificationPulse () {
    this.els.unread.elements.forEach(element => {
      element.ariaHidden = this.notificationsClicked?.includes(
        element.dataset.id,
      )
    })
  }

  get unreadNotificationCount () {
    const current = this.dataset.ids.split(',')
    const clicked = (this.notificationsClicked || '').split(',').filter(Boolean)
    return current.filter(id => !clicked.includes(id)).length
  }

  get notificationsRead () {
    return window.localStorage.getItem('site-notification:ids')
  }

  set notificationsRead (ids) {
    return window.localStorage.setItem('site-notification:ids', ids)
  }

  get notificationsClicked () {
    return window.localStorage.getItem('site-notification:clicked')
  }

  set notificationsClicked (id) {
    const ids = `${this.notificationsClicked},${id}`
    return window.localStorage.setItem('site-notification:clicked', ids)
  }
}

if (!customElements.get('site-notifications')) {
  customElements.define('site-notifications', SiteNotifications)
}
